import { useState, useEffect } from "react";
import reborder from "@/assets/reborder.png";
import iconStore from "@/utils/iconStore";

const usePrizeTransformData = (rawData) => {
  const [transformedData, setTransformedData] = useState([]);
  const [currencyListLoaded, setCurrencyListLoaded] = useState(false);

  const reImg = {
    src: reborder,
    width: "2.8rem",
    top: "0.5rem",
  };

  useEffect(() => {
    const checkCurrencyList = () => {
      if (iconStore.currencyList && iconStore.currencyList.length > 0) {
        setCurrencyListLoaded(true);
      } else {
        console.warn("iconStore.currencyList is not loaded yet");
      }
    };
    checkCurrencyList();
    const intervalId = setInterval(checkCurrencyList, 1000);
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    if (rawData && currencyListLoaded) {
      const prizeTransformData = (rawData) => {
        return rawData.wheels.map((wheel) => {
          const relatedPrizes = rawData.prizes;
          const transformedPrizes = relatedPrizes.map((prize, index) => {
            const matchedCurrency = iconStore.currencyList.find(
              (currency) => currency.id === prize.currency_id
            );
            const currencyImg = matchedCurrency
              ? {
                  src: `${matchedCurrency.icon}`,
                  width: "1.8rem",
                  top: "0.7rem",
                  left: "-0.1rem",
                }
              : null;

            return {
              fonts: [
                {
                  text: prize.value,
                  top: "2.99rem",
                  left: "-0.11rem",
                  fontSize: "0.6rem",
                  fontColor: "white",
                },
              ],
              imgs: [reImg, currencyImg].filter(Boolean),
              value: prize.value,
              id: prize.id,
              priority: relatedPrizes.length - index,
              rate: 1 / (index + 1),
              currency_id: prize.currency_id,
              order: prize.order + 1,
              create_at: prize.create_at,
            };
          });

          return {
            cost_type: wheel.cost_type,
            id: wheel.id,
            cost_value: wheel.cost_value,
            enable: wheel.enable,
            title: `${wheel.cost_type} for game.`,
            max_prize: relatedPrizes.length,
            prizes: transformedPrizes,
            update_at: wheel.create_at,
            create_at: wheel.create_at,
          };
        });
      };

      setTransformedData(prizeTransformData(rawData));
    }
  }, [rawData, currencyListLoaded]);

  return transformedData;
};

export default usePrizeTransformData;
